// extracted by mini-css-extract-plugin
export default {"questionVoice":"Game14VoiceBtn_questionVoice__U+fyg","answerVoice":"Game14VoiceBtn_answerVoice__dM2Pp"};